import { videos, categories } from "@/mocks/videos";
import type { Video } from "@/types/video";

export function formatPlays(plays: number): string {
  if (plays >= 100000000) return `${(plays / 100000000).toFixed(1)}亿`;
  if (plays >= 10000) return `${(plays / 10000).toFixed(1)}万`;
  return String(plays);
}

export function formatDate(date: string): string {
  const parts = date.split("-");
  if (parts.length < 3) return date;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export function getAllVideos(): Video[] {
  return videos as Video[];
}

export function getVideoById(id: string): Video | undefined {
  return (videos as Video[]).find((v) => v.id === id);
}

export function getCategoryById(id: string) {
  return categories.find((c) => c.id === id);
}

export function getVideosByCategory(categoryId: string): Video[] {
  return (videos as Video[]).filter((v) => v.categoryId === categoryId);
}

export function getRelatedVideos(video: Video, limit = 6): Video[] {
  const sameCategory = (videos as Video[]).filter(
    (v) => v.categoryId === video.categoryId && v.id !== video.id
  );
  const others = (videos as Video[]).filter(
    (v) => v.categoryId !== video.categoryId && v.id !== video.id
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function searchVideos(keyword: string, categoryId?: string): Video[] {
  const kw = keyword.trim().toLowerCase();
  return (videos as Video[]).filter((v) => {
    const matchKeyword =
      !kw ||
      v.title.toLowerCase().includes(kw) ||
      v.description.toLowerCase().includes(kw) ||
      v.tags.some((t) => t.toLowerCase().includes(kw));
    const matchCategory = !categoryId || v.categoryId === categoryId;
    return matchKeyword && matchCategory;
  });
}